<template>
  <div>
    关于我们
  </div>
</template>

<script>
  export default {
    name: 'SettingsAbout'
  }
</script>

<style scoped>

</style>
